import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import { theme } from '../theme';
import { NotificationButton } from './NotificationButton';
import { useNavigate } from 'react-router-dom';
import { Notification } from '../types';

interface AppHeaderProps {
  title?: string;
  showUserInfo?: boolean;
  showBackButton?: boolean;
  children?: React.ReactNode;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ 
  title, 
  showUserInfo = true, 
  showBackButton = false,
  children 
}) => {
  const { user } = useAuth();
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const handleNotificationClick = (notification: Notification) => {
    if (notification.type === 'MATCH_FINISHED' && notification.matchId) {
      navigate(`/match/${notification.matchId}`);
    } else if (notification.type === 'REVIEWS_RECEIVED_BATCH' && notification.matchId) {
      navigate('/profile');
    } else if (notification.type === 'REPORT_VALIDATED' && notification.matchId) {
      navigate('/profile');
    } else if (notification.type === 'PLAYER_JOINED_MATCH' && notification.matchId) {
      navigate(`/match/${notification.matchId}`);
    } else if (notification.type === 'PLAYER_LEFT_MATCH' && notification.matchId) {
      navigate(`/match/${notification.matchId}`);
    } else if (notification.type === 'GROUP_INVITATION') {
      navigate('/groups');
    }
  };

  // AppHeader no se usa, el Sidebar maneja el header en mobile y desktop
  return null;
}; 